import * as React from "react";
import { Text, View, StyleSheet, Link } from "@react-pdf/renderer";
import { useTheme } from "../../hooks/use-theme";
import { IconText } from "../icon-text";
import { DateRange } from "../date-range";

const styles = StyleSheet.create({
  title: {
    fontSize: 12,
    fontFamily: "Quicksand",
    fontWeight: "bold",
  },
  metaInfoContainer: {
    flexDirection: "row",
    marginTop: 4,
    alignItems: "center",
  },
  workPlace: {
    fontSize: 10,
    fontFamily: "Quicksand",
    fontWeight: "bold",
  },
  description: {
    fontSize: 8,
    fontFamily: "OpenSans",
    marginTop: 4,
  },
  content: {
    marginTop: 10,
  },
});

const Title = ({ children, style }) => {
  return <Text style={[styles.title, style]}>{children}</Text>;
};

const WorkPlace = ({ children, url, style }) => {
  const theme = useTheme();

  const commonStyle = [
    styles.workPlace,
    { color: theme.colors.primary },
    style,
  ];

  if (url) {
    return (
      <Link src={url}>
        <Text style={commonStyle}>{children}</Text>
      </Link>
    );
  }

  return <Text style={commonStyle}>{children}</Text>;
};

export const WorkPost = ({
  style,
  title,
  companyName,
  companyUrl,
  location,
  startAt,
  endAt,
  description,
  children,
}) => {
  const theme = useTheme();

  return (
    <View style={style}>
      <Title>{title}</Title>
      <View style={styles.metaInfoContainer}>
        {companyName ? (
          <WorkPlace url={companyUrl}>{companyName}</WorkPlace>
        ) : null}
        <DateRange
          style={{ marginLeft: companyName ? "auto" : 0, marginRight: 16 }}
          startAt={startAt}
          endAt={endAt}
        />
        <IconText text={location} iconName="location" />
      </View>
      {description && (
        <Text style={[styles.description, { color: theme.colors.text }]}>
          {description}
        </Text>
      )}
      {React.Children.count(children) > 0 ? (
        <View style={styles.content}>{children}</View>
      ) : null}
    </View>
  );
};

WorkPost.Title = Title;

WorkPost.WorkPlace = WorkPlace;
